import { useTenant } from "@/app/Organisations/Hooks/useTenant";
import { integrations } from "@/app/Settings/Integrations/Common/integrations";
import { FeatureFlagType, IntegrationType } from "@/gql/graphql";
import { useFeatureFlag } from "@/app/Meta/utils/useFeatureFlag";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { supplierIntegrationList } from "@/app/Settings/Settings/GraphQL/integrationQueries";

export function useVisibleIntegrations(supplierId: string) {
  const isJucyEnabled = useFeatureFlag(FeatureFlagType.JucyIntegration);
  const isRcmEnabled = useFeatureFlag(FeatureFlagType.RcmIntegration);
  const isCampermanEnabled = useFeatureFlag(
    FeatureFlagType.CampermanIntegration,
  );
  const isCampermanGapFillerEnabled = useFeatureFlag(
    FeatureFlagType.CampermanGapFillerIntegration,
  );
  const isRoadsurferEnabled = useFeatureFlag(
    FeatureFlagType.RoadsurferIntegration,
  );
  const { isAdmin } = useTenant();
  const { data } = useSuspenseGqlQuery(supplierIntegrationList, {
    supplier_id: supplierId,
  });

  return integrations.filter((integration) => {
    if (data.integrations.data.some((item) => item.type === integration.type)) {
      return false;
    }

    if (integration.type === IntegrationType.Jucy) {
      return isJucyEnabled;
    }

    if (integration.type === IntegrationType.Rcm) {
      return isRcmEnabled;
    }

    if (integration.type === IntegrationType.Camperman) {
      return isCampermanEnabled;
    }

    if (integration.type === IntegrationType.CampermanGapFiller) {
      return isCampermanGapFillerEnabled;
    }

    if (integration.type === IntegrationType.Roadsurfer) {
      return isRoadsurferEnabled;
    }

    if (integration.type === IntegrationType.Click4Wheels) {
      return isAdmin;
    }

    return true;
  });
}
